import { render, staticRenderFns } from "./BeneficiaryManager.vue?vue&type=template&id=ffae26f6"
import script from "./BeneficiaryManager.vue?vue&type=script&lang=js"
export * from "./BeneficiaryManager.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryManager.vue?vue&type=style&index=0&id=ffae26f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports